import { passCodes } from '../passCodes';
import track33 from '../../../../assets/audio/tracks/track33.mp3';

export const step33statue = {
    id: 31,
    title: '15. stanoviště',
    taskText: `
        <p>
            Ahaa to je on, co to jenom drží?
        </p>
    `,
    audio: track33,
    snowAudio: track33,
    codeInputText: ' ',
    catImage: 1,
    codeInputPassCodeRegexp: passCodes[24],
    additionalInfo: 'Odpovědí je jedno slovo.',
    hints: [
        {
            text: 'Přečtěte si tabulku u sochy, co pan Krčil vynalezl.',
        },
        {
            text: 'Kódem je: síťovka',
            solution: true,
        },
    ],
    snowHints: [
        {
            text: 'Naši rodiče to nosili na nákup.',
        },
        {
            text: 'Kódem je: síťovka',
            solution: true,
        },
    ],
};
